"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { MapPin, Clock, MessageSquare } from "lucide-react";
export default function MapAndHours() {
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return;
}